import { create } from 'zustand';

interface PusherLoaderState {
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
}

/**
 * Simple Zustand store to manage Pusher-specific loading state.
 * Used for operations that need manual loader control (e.g., duplicate event with Pusher).
 */
export const usePusherLoaderStore = create<PusherLoaderState>((set) => ({
  isLoading: false,
  setLoading: (loading: boolean) => set({ isLoading: loading }),
}));
